// Helper function to ensure value is an array
const ensureArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

// Global loading state handler
let loadingHandlers = [];

// Register a loading state handler
export const registerWOLoadingHandler = (handler) => {
  loadingHandlers.push(handler);
  return () => {
    loadingHandlers = loadingHandlers.filter((h) => h !== handler);
  };
};

// Update all registered handlers with the current loading state
const updateLoadingState = (isLoading, message = null) => {
  loadingHandlers.forEach((handler) => handler(isLoading, message));
};

// Utility function to fetch WO data from Zoho Creator
export const fetchWONames = async (forceRefresh = false) => {
  // Always fetch fresh data, ignore cache

  const conn_name = "crmwidgetconnection";
  const baseUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Workorder1_Report";

  // Set loading state
  updateLoadingState(true, "Loading WO data...");

  // No cache, just fetch and return
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Fetching WO data from API...");

      // Simple API request without pagination
      const req_data = {
        method: "GET",
        url: baseUrl,
        param_type: 1,
      };

      const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

      // Log the full response for debugging
      console.log("WO API response:", response);

      // Extract and format WO data
      let formattedWONames = [];
      if (
        response &&
        response.code === "SUCCESS" &&
        response.details &&
        response.details.statusMessage &&
        Array.isArray(response.details.statusMessage.data)
      ) {
        const records = response.details.statusMessage.data;
        formattedWONames = records.map((item) => ({
          id: item.ID,
          workorderId: item.Workorder_ID || "",
          doName: item["Design_Order.DO_Name"] || "",
        }));
      }

      setTimeout(() => {
        updateLoadingState(false);
        resolve(formattedWONames);
      }, 500);
    } catch (error) {
      console.error("Error fetching WO Names:", error);
      resolve([]);
    } finally {
      setTimeout(() => {
        updateLoadingState(false);
      }, 500);
    }
  });
};

// For backwards compatibility with components that still import fetchSONames
export const fetchSONames = fetchWONames;

// Add proper implementation of filterWOsBySearchTerm
export const filterWOsBySearchTerm = (woList, searchTerm) => {
  // Ensure woList is an array
  const woArray = ensureArray(woList);

  if (!searchTerm || typeof searchTerm !== "string" || woArray.length === 0) {
    return woArray;
  }

  const normalizedSearchTerm = searchTerm.toLowerCase().trim();

  // Filter WOs that match the search term
  return woArray.filter(
    (wo) =>
      wo &&
      ((wo.workorderId &&
        wo.workorderId.toLowerCase().includes(normalizedSearchTerm)) ||
        (wo.doName && wo.doName.toLowerCase().includes(normalizedSearchTerm)))
  );
};

// For backwards compatibility with components still using filterSOsBySearchTerm
export { filterWOsBySearchTerm as filterSOsBySearchTerm };

// Export default for compatibility
export default filterWOsBySearchTerm;
